import axios from 'axios'
import { makeQueryString } from '@/utils/Query.js'

const API_BASE_URL = process.env.VUE_APP_API_URL;

const config = {
    baseUrl: API_BASE_URL + "/gsapi/gis/" 
};

const gisAPIDFN = {
    gisAPI: (APIName, conditions, paths) => {
        return gisAPI[APIName](conditions, paths);
    }
};

const gisAPI = {
    API_BASE_URL: `${API_BASE_URL}`,
  
    // 1. 구/군 조회 API
    searchGungu: (conditions = {}, paths) => {
        const uri = paths || "searchGungu"; // 호출 시 /gsapi/gis/searchGungu 가 됩니다.
        return axios.get(`${config.baseUrl}${uri}${makeQueryString(conditions)}`);
    },
  
    // 2. 동(Dong) 조회 API
    searchDong: (conditions = {}, paths) => {
        const uri = paths || "searchDong"; 
        return axios.get(`${config.baseUrl}${uri}${makeQueryString(conditions)}`);
    }
};

export { gisAPIDFN, gisAPI };
